export default __webpack_public_path__ + "static/media/reference_bl_5.07a3e2a2.svg";